import { createSelector } from "reselect";

import {
  getPinnedDashboardIds,
  isCumulEnabled,
  isCumulPromotionalUIVisited,
  isCurrentUserManager,
  isCurrentUserOwner,
} from "@app/store/iam";
import { getUsers } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";
import resolveReportsDefaultPath from "@app/util/resolveReportsDefaultPath";

const cumulState = (state: RootState) => state.cumul;
export const getCumulAuth = createSelector(cumulState, ({ cumulAuth }) => cumulAuth);

export const getCumulDashboardList = createSelector(
  cumulState,
  ({ cumulDashboardList }) => cumulDashboardList ?? []
);

export const getVisibleDashboardId = createSelector(
  cumulState,
  ({ dashboardIdToOpen }) => dashboardIdToOpen
);

export const getPinnedDashboards = createSelector(
  getPinnedDashboardIds,
  getCumulDashboardList,
  (pinnedIds, dashboards) => {
    const pinnedIdsSet = new Set(pinnedIds);
    return (dashboards ?? [])
      .filter(({ id }) => pinnedIdsSet.has(id))
      .sort((a, b) => (a.name.en ?? "").localeCompare(b.name.en ?? ""));
  }
);

export const getReportsDefaultPath = createSelector(
  isCumulEnabled,
  isCumulPromotionalUIVisited,
  isCurrentUserOwner,
  isCurrentUserManager,
  getPinnedDashboards,
  getUsers,
  (cumulEnabled, cumulPromotionalUIVisited, isOwner, isManager, pinnedDashboards, users) =>
    resolveReportsDefaultPath({
      isCumulEnabled: cumulEnabled,
      isCumulPromotionalUIVisited: cumulPromotionalUIVisited,
      isOwnerOrManager: !!(isOwner || isManager),
      pinnedDashboards,
      userCount: users.length,
    })
);

export const isCumulSaving = createSelector(cumulState, ({ saving }) => saving);
